function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import * as React from 'react';
import PropTypes from 'prop-types';
import Checkbox from "./Checkbox";
import { css } from "../../styles/theme";
import { pure, compose, setDisplayName } from 'recompose';
import isEqual from 'lodash/isEqual';
import isUndefined from 'lodash/isUndefined';
import { LABEL_POSITION } from "./CheckboxBase";

function getOptions(options) {
  return options.map(function (option) {
    if (typeof option === 'string') {
      return {
        label: option,
        value: option
      };
    }

    return option;
  });
}

var CheckboxGroup =
/*#__PURE__*/
function (_React$Component) {
  _inherits(CheckboxGroup, _React$Component);

  function CheckboxGroup(props) {
    var _this;

    _classCallCheck(this, CheckboxGroup);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(CheckboxGroup).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "toggleOption", function (option) {
      var optionIndex = _this.state.value.indexOf(option.value);

      var value = _toConsumableArray(_this.state.value);

      if (optionIndex === -1) {
        value.push(option.value);
      } else {
        value.splice(optionIndex, 1);
      }

      if (!('value' in _this.props)) {
        _this.setState({
          value: value
        });
      }

      var onChange = _this.props.onChange;

      if (onChange) {
        onChange(value);
      }
    });

    _this.state = {
      value: props.value || props.defaultValue || []
    };
    return _this;
  }

  _createClass(CheckboxGroup, [{
    key: "getChildContext",
    value: function getChildContext() {
      return {
        checkboxGroup: {
          toggleOption: this.toggleOption,
          value: this.state.value,
          disabled: this.props.disabled
        }
      };
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      var value = nextProps.value;

      if (!isUndefined(value) && !isEqual(value, this.props.value)) {
        this.setState({
          value: value || []
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          rootClassName = _this$props.rootClassName,
          checkboxRootClassName = _this$props.checkboxRootClassName,
          options = _this$props.options,
          disabled = _this$props.disabled,
          childrenAlt = _this$props.children,
          isVertical = _this$props.isVertical,
          labelPosition = _this$props.labelPosition,
          renderCheckbox = _this$props.renderCheckbox,
          shouldWrapText = _this$props.shouldWrapText,
          tabIndex = _this$props.tabIndex;
      var value = this.state.value;
      var children = childrenAlt;
      var style = {
        display: isVertical ? 'flex' : 'inline',
        whiteSpace: shouldWrapText ? 'normal' : 'nowrap'
      };

      if (options && options.length > 0) {
        children = getOptions(options).map(function (option, index) {
          return React.createElement(Checkbox, {
            key: option.value,
            disabled: !isUndefined(option.disabled) ? option.disabled : disabled,
            value: option.value,
            checked: value.indexOf(option.value) !== -1,
            onChange: function onChange() {
              return _this2.toggleOption(option);
            },
            rootClassName: checkboxRootClassName,
            style: style,
            tabIndex: tabIndex,
            labelPosition: labelPosition
          }, renderCheckbox ? renderCheckbox(_objectSpread({}, option, {
            index: index
          })) : option.label);
        });
      }

      return React.createElement("div", css(rootClassName), children);
    }
  }]);

  return CheckboxGroup;
}(React.Component);

_defineProperty(CheckboxGroup, "propTypes", {
  renderCheckbox: PropTypes.func,
  checkboxRootClassName: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  children: PropTypes.node,
  defaultValue: PropTypes.array,
  disabled: PropTypes.bool,
  isVertical: PropTypes.bool,
  labelPosition: PropTypes.oneOf(Object.keys(LABEL_POSITION)),
  shouldWrapText: PropTypes.bool,
  onChange: PropTypes.func,
  options: PropTypes.array.isRequired,
  rootClassName: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  value: PropTypes.array,
  tabIndex: PropTypes.number
});

_defineProperty(CheckboxGroup, "childContextTypes", {
  checkboxGroup: PropTypes.any
});

_defineProperty(CheckboxGroup, "defaultProps", {
  options: []
});

export default compose(setDisplayName('CheckboxGroup'), pure)(CheckboxGroup);